import { render, staticRenderFns } from "./AppHeaderBotControl.vue?vue&type=template&id=725352a4&"
import script from "./AppHeaderBotControl.vue?vue&type=script&lang=js&"
export * from "./AppHeaderBotControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports